exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bt_green a[data-v-e3ab17c2]{width:320px}", ""]);

// exports
